<template>
  <div>
    <v-card elevation="2" outlined shaped tile class="mb-2">
      <v-card-title>Informes Marcas</v-card-title>

      <v-dialog  v-if="selected" scrollable v-model="showEdit" >
        <v-form ref="form" v-model="valid" lazy-validation>
          <v-card>
            <v-card-title>
              <span class="text-h5">{{ formTitle }}</span>
            </v-card-title>

            <v-card-text>

              <v-container>
                <v-row>
                  <v-col cols="4">
                    <v-text-field
                      v-model="selected.name"
                      v-bind:label="$t('brands.name')"
                      required
                      :rules="requiredRules"
                    ></v-text-field>

                  </v-col>
                  <v-col cols="5">
                    <div class="d-flex">
                      <v-autocomplete
                        v-model="selected.brandId"
                        v-bind:label="$t('brands.brand')"
                        v-bind:placeholder="$t('start_typing_to_search')"
                        item-text="name"
                        item-value="id"
                        :search-input.sync="search_brand"
                        :loading="isBrandSearching"
                        :items="filtered_brands"
                        hide-no-data
                        hide-selected
                        filled
                        clearable
                        required
                        :rules="requiredRules"
                        @change="onChangeBrand"
                      ></v-autocomplete>
                    </div>
                  </v-col>

                  <v-col cols="3">
                    <v-radio-group
                      v-model="selected.isDisabled"
                      row
                      required
                      :rules="requiredRules"
                    >
                      <v-radio label="Activo" :value="false"></v-radio>
                      <v-radio label="Inactivo" :value="true"></v-radio>
                    </v-radio-group>
                  </v-col>
                  <v-col cols="12">
                    <v-autocomplete
                      v-model="selected.surveys"
                      :items="surveyOptions"
                      item-text="name"
                      item-value="id"
                      label="Surveys"
                      multiple
                      chips
                      clearable
                      :loading="isSurveyLoading"
                      :rules="requiredRules"
                      placeholder="Select surveys"
                    ></v-autocomplete>
                  </v-col>
                </v-row>

                <v-row cols="12" v-if="reportColumns">
                  <template v-if="!reportColumns.length">
                    <b-alert
                      style="width: 100%;"
                      v-if="selected && selected.id"
                      show
                      >Aún no has creado ninguna definición de columnas.
                      <v-btn color="primary" text @click="editColumn">
                        Añadir
                      </v-btn>
                    </b-alert>
                    <b-alert style="width: 100%;" v-else show>
                      Pulsa a guardar antes de poder añadir columnas</b-alert
                    >
                  </template>

                  <div v-else class="w-full">
                    <table class="table table-sm">
                      <thead>
                        <tr>
                          <th scope="col">Acciones</th>
                          <th scope="col">Orden</th>
                          <th scope="col">Nombre Columna</th>
                          <th scope="col">Valor Por Defecto</th>
                          <th scope="col">Opciones</th>
                          <th scope="col">Obligatoria?</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr
                          :key="`report_column_${k}`"
                          v-for="(column, k) in reportColumns"
                        >
                          <td>
                            <div class="d-flex">
                              <b-button
                                @click="moveColumn(column, true)"
                                squared
                                variant="outline-secondary"
                                class="px-1 mr-1"
                                size="sm"
                              >
                                <b-icon icon="arrow-up"></b-icon>
                              </b-button>

                              <b-button
                                @click="moveColumn(column, false)"
                                squared
                                variant="outline-secondary"
                                class="px-1 mr-2"
                                size="sm"
                              >
                                <b-icon icon="arrow-down"></b-icon>
                              </b-button>

                              <b-button
                                squared
                                variant="outline-secondary"
                                @click="editColumn(column)"
                                class="px-1 mr-1"
                                size="sm"
                              >
                                <b-icon icon="pencil-square"></b-icon>
                              </b-button>

                              <b-button
                                squared
                                variant="outline-secondary"
                                @click="removeColumn(column)"
                                class="px-1"
                                size="sm"
                              >
                                <b-icon icon="trash" variant="danger"></b-icon>
                              </b-button>

                              <div></div>
                            </div>
                          </td>
                          <td>
                            <b>{{ column.order }}</b>
                          </td>

                          <td>{{ column.name }}</td>

                          <td>{{ column.defaultValue || "-" }}</td>

                          <td style="max-width: 200px">
                            {{
                              column.options && column.options.length
                                ? column.options
                                : "-"
                            }}
                          </td>

                          <td>{{ column.isMandatory ? "Si" : "No" }}</td>
                        </tr>
                      </tbody>
                    </table>

                    <div class="d-flex">
                      <v-btn
                        color="primary"
                        small
                        @click="editColumn"
                        class="mr-1"
                      >
                        Nueva
                      </v-btn>
                    </div>
                  </div>
                </v-row>
              </v-container>
            </v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="blue darken-1" text @click="closeEditDialog">
                {{ $t("cancel") }}
              </v-btn>
              <v-btn color="blue darken-1" text @click="onSaveClick(selected)">
                {{ $t("save") }}
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-form>
      </v-dialog>

      <v-dialog v-model="dialogDelete" max-width="600px">
        <v-card>
          <v-card-title class="text-h6"
            >Estás seguro que quieres borrar este informe?</v-card-title
          >
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" text @click="closeDelete">{{
              $t("cancel")
            }}</v-btn>
            <v-btn color="blue darken-1" text @click="deleteItemConfirm"
              >OK</v-btn
            >
            <v-spacer></v-spacer>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog
        v-if="columnSelected"
        v-model="showEditColumn"
        max-width="500px"
      >
        <v-form ref="column_form" v-model="valid" lazy-validation>
          <v-card>
            <v-card-title class="text-h6">Añade una columna</v-card-title>
            <v-card-text>
              <v-text-field
                v-model="columnSelected.name"
                label="Nombre"
                required
                :rules="requiredRules"
              ></v-text-field>

              <v-text-field
                v-model="columnSelected.defaultValue"
                label="Valor por defecto"
              ></v-text-field>

              <v-combobox
                v-model="columnSelected.options"
                label="Añade valores predefinidos"
                multiple
                chips
              ></v-combobox>

              <v-radio-group
                v-model="columnSelected.isMandatory"
                row
                required
                :rules="requiredRules"
              >
                <v-radio label="Obligatoria" :value="true"></v-radio>
                <v-radio label="No obligatoria" :value="false"></v-radio>
              </v-radio-group>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                color="blue darken-1"
                text
                @click="() => (this.showEditColumn = false)"
                >{{ $t("cancel") }}</v-btn
              >
              <v-btn color="blue darken-1" text @click="addColumnConfirm"
                >OK</v-btn
              >
              <v-spacer></v-spacer>
            </v-card-actions>
          </v-card>
        </v-form>
      </v-dialog>

      <v-card-text>
        <v-row>
          <v-col cols="12" sm="12" md="12">
            <v-btn color="primary" dark class="mb-2" @click="onItemEdit">
              {{ $t("newitem") }}
            </v-btn>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" sm="12" md="12">
            <ve-table
              ref="tableRefreports"
              id="reports_table"
              fixed-header
              max-height="calc(100vh - 330px)"
              :columns="columns"
              :table-data="reports"
              :border-around="true"
              :border-x="true"
              :border-y="true"
              :sort-option="sortOption"
              :cell-style-option="cellStyleOption"
            />
            <div v-show="showEmpty" class="empty-data">Data Empty.</div>
            <div class="table-pagination mt-2 text-right">
              <ve-pagination
                :total="totalreports"
                :page-index="pageIndex"
                :page-size="pageSize"
                :page-size-option="pageOptions"
                @on-page-number-change="pageNumberChange"
                @on-page-size-change="pageSizeChange"
              />
            </div>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import ApiService from "@/services/apiService";
import { logInfo, logError, arrayMove } from "@/utils";
import _ from "lodash";

export default {
  name: "ReportBrands",
  data: function() {
    return {
      filterable_col_list: ["brand", "name", "isDisabled"],
      cellStyleOption: {
        headerCellClass: ({ column, rowIndex }) => {
          if (this.filterable_col_list.includes(column.field)) {
            return "filterable-column " + column.field;
          }
        }
      },
      loadingInstance: null,
      sorting: null,
      sortOption: {
        sortChange: params => {
          this.sortChange(params);
        }
      },
      pageIndex: 1,
      pageSize: 100,
      pageOptions: [10, 50, 100],
      filterCriteria: {
        name: {},
        brand: {},
        isDisabled: {}
      },
      showEmpty: false,

      totalreports: 0,
      reports: [],

      valid: true,
      requiredRules: [v => v != null || "Required"],
      selected: null,
      editedIndex: -1,
      deleteItemId: -1,
      showEdit: false,
      showEditColumn: true,
      dialogDelete: false,
      columnSelected: null,
      search_brand: null,
      isBrandSearching: false,
      filtered_brands: [],
      reportColumns: [],
      isParentSearching: false,
      filtered_parents: [],
      surveyOptions: [],
      isSurveyLoading: false
    };
  },
  watch: {
    dialogDelete(val) {
      val || this.closeDelete();
    },
    async search_brand(val) {
      await this.search_brand_list(val);
    }
  },
  computed: {
    formTitle() {
      return this.editedIndex === -1 || this.editedIndex === undefined
        ? "Nuevo informe"
        : "Editar informe";
    },
    columns() {
      return [
        {
          key: "id",
          title: "ID",
          field: "id",
          align: "left",
          width: "7%",
          sortBy: "ASC"
        },
        {
          key: "brand",
          title: this.$t("brands.brand"),
          field: "brand",
          align: "left",
          sortBy: "",
          width: "20%",
          renderBodyCell: ({ row, column, rowIndex }, h) => {
            return <span>{row.brand && row.brand.name}</span>;
          },
          filterCustom: {
            defaultVisible: false,
            render: ({ showFn, closeFn }, h) => {
              return (
                <div class="custom-filter">
                  <filterableAjaxCheckboxes
                    v-model={this.filterCriteria["brand"]}
                    apiUrl={`brands/brand-reports/getfilterlist`}
                    columnName={`brand`}
                    isFullText={true}
                    filterCriteria={this.filterCriteria["brand"]}
                  />
                  <div class="custom-filter-operation">
                    <v-btn
                      color="blue darken-1"
                      text
                      on-click={() => this.searchCancel(closeFn, "brand")}
                    >
                      {this.$t("cancel")}
                    </v-btn>
                    <v-btn
                      color="blue darken-1"
                      text
                      on-click={() => this.searchConfirm(closeFn)}
                    >
                      {this.$t("Search")}
                    </v-btn>
                  </div>
                </div>
              );
            }
          }
        },

        {
          key: "name",
          title: "Nombre",
          field: "name",
          align: "left",
          sortBy: "",
          width: "15%",
          renderBodyCell: ({ row, column, rowIndex }, h) => {
            return <span>{row.name}</span>;
          }
        },

        {
          key: "isDisabled",
          title: "Estado",
          field: "isDisabled",
          align: "left",
          sortBy: "",
          width: "15%",
          renderBodyCell: ({ row, column, rowIndex }, h) => {
            return <span>{row.isDisabled ? "inactivo" : "activo"}</span>;
          },
          filterCustom: {
            defaultVisible: false,
            render: ({ showFn, closeFn }, h) => {
              return (
                <div class="custom-filter">
                  <filterableAjaxCheckboxes
                    v-model={this.filterCriteria["isDisabled"]}
                    apiUrl={`reporting/brand-reports/getfilterlist`}
                    columnName={`isDisabled`}
                    isFullText={true}
                    filterCriteria={this.filterCriteria["isDisabled"]}
                  />
                  <div class="custom-filter-operation">
                    <v-btn
                      color="blue darken-1"
                      text
                      on-click={() => this.searchCancel(closeFn, "isDisabled")}
                    >
                      {this.$t("cancel")}
                    </v-btn>
                    <v-btn
                      color="blue darken-1"
                      text
                      on-click={() => this.searchConfirm(closeFn)}
                    >
                      {this.$t("Search")}
                    </v-btn>
                  </div>
                </div>
              );
            }
          }
        },

        {
          key: "actions",
          title: this.$t("salesforce.Edit"),
          field: "actions",
          align: "center",
          width: "10%",
          renderBodyCell: ({ row, column, rowIndex }, h) => {
            return (
              <div>
                <v-icon
                  medium
                  color="primary"
                  class="mr-2"
                  on-click={() => this.onItemEdit(row)}
                >
                  mdi-pencil
                </v-icon>
                <v-icon
                  medium
                  color="error"
                  on-click={() => this.onItemRemove(row.id)}
                >
                  mdi-delete
                </v-icon>
              </div>
            );
          }
        }
      ];
    }
  },
  methods: {
    async search_brand_list(val) {
      if (!val) val = "";
      let fetch_url = "brands/brand-list?filter_name=" + val;
      const resp = await ApiService.get(fetch_url);
      this.filtered_brands = resp.data;
    },

    pageNumberChange(pageIndex) {
      this.pageIndex = pageIndex;
      this.getDataFromApi();
    },

    pageSizeChange(pageSize) {
      this.pageIndex = 1;
      this.pageSize = pageSize;
      this.getDataFromApi();
    },

    show() {
      this.loadingInstance = this.$veLoading({
        target: document.querySelector("#reports_table"),
        name: "flow" // gird, flow, wave, bounce,
      });
      this.loadingInstance.show();
    },

    close() {
      this.loadingInstance.close();
    },

    async onChangeBrand() {
      this.isSurveyLoading = true;
      this.surveyOptions = [];
      // Call the new API for surveys
      if (this.selected.brandId) {
        try {
          const payload = {
            brands: [this.selected.brandId],
            search: this.search_brand || "",
            role: 'admin',
          };
          const resp = await ApiService.post("/salesforce/users/get_brand_surveys", payload);
          this.surveyOptions = resp.success && resp.survey_data ? resp.survey_data : [];
        } catch (e) {
          this.surveyOptions = [];
        }
      }
      this.isSurveyLoading = false;
    },

    async onItemEdit(item) {
      this.search_brand = "";
      this.reportColumns = [];
      this.selected = { ...item };

      // If surveyIds exist, set selected.surveys for the dropdown
      if (item.surveyIds) {
        try {
          // surveyIds might be a JSON string or array
          let ids = Array.isArray(item.surveyIds)
            ? item.surveyIds
            : JSON.parse(item.surveyIds);
          this.selected.surveys = ids;
        } catch (e) {
          this.selected.surveys = [];
        }
      } else {
        this.selected.surveys = [];
      }

      this.editedIndex = this.selected.id;
      await this.fetchColumns(this.editedIndex);

      // Fetch surveys for the selected brand if editing
      if (this.selected.brandId) {
        await this.onChangeBrand();
      }
      this.showEdit = true;
      
        // If opening a new report (no id), clear surveyOptions
        if (!item.id) {
          this.surveyOptions = [];
        }
    },

    sortChange(params) {
      this.sorting = params;
      this.getDataFromApi();
    },

    moveColumn(item, up) {
      let arr = this.reportColumns;
      const idx = arr.findIndex(el => el.id === item.id);
      if ((up && idx === 0) || (!up && idx === arr.length - 1)) {
        return;
      }
      const toIdx = up ? idx - 1 : idx + 1;
      arr = arrayMove(arr, idx, toIdx);
      arr.forEach((el, i) => (el.order = i + 1));
      this.reportColumns = arr;
    },

    editColumn(item) {
      this.columnSelected = item;
      this.columnSelected.brandReportId = this.selected.id;
      if (!this.columnSelected.order) {
        this.columnSelected.order = this.reportColumns.length
          ? Math.max(...this.reportColumns.map(el => el.order)) + 1
          : 1;
      }
      this.showEditColumn = true;
    },

    async removeColumn(item) {
      if (confirm("Seguro que quieres eliminar esta columna?")) {
        await ApiService.delete(`reporting/brand-reports/columns/${item.id}`);
        await this.fetchColumns(this.editedIndex);
      }
    },

    closeEditDialog() {
        this.showEdit = false;
        this.search_brand = "";
        this.surveyOptions = [];
        this.$nextTick(() => {
          this.selected = null;
        this.editedIndex = -1;
      });
    },

    async fetchColumns(id) {
      const { data } = await ApiService.get(
        `reporting/brand-reports/${id}/columns`
      );
      this.reportColumns = _.sortBy(data, "order");
    },

    async addColumnConfirm() {
      if (this.$refs.column_form.validate()) {
        if (this.columnSelected.id) {
          await ApiService.put(
            `reporting/brand-reports/columns/${this.columnSelected.id}`,
            this.columnSelected
          );
          logInfo("Columna modificada");
        } else {
          await ApiService.post(
            `reporting/brand-reports/columns`,
            this.columnSelected
          );
          logInfo("Columna añadida");
        }
        await this.fetchColumns(this.editedIndex);
        this.showEditColumn = false;
      }
    },

    async onSaveClick(item) {
      if (this.$refs.form.validate()) {
        let body = { ...item };
        // Ensure surveys are sent as an array of IDs
        body.surveyIds = Array.isArray(this.selected.surveys) && this.selected.surveys.length ? JSON.stringify([...this.selected.surveys]) : null;
        if (body.id) {
          await ApiService.put(`reporting/brand-reports/${body.id}`, body);
        } else {
          await ApiService.post(`reporting/brand-reports`, body);
        }
        await ApiService.put(
          `reporting/brand-reports/column-order`,
          this.reportColumns
        );

        logInfo("report actualizado");
        this.showEdit = false;
        await this.getDataFromApi();
        this.search_brand = "";
      }
    },

    closeDelete() {
      this.dialogDelete = false;
      this.$nextTick(() => {
        this.deleteItemId = -1;
      });
    },

    onItemRemove(item_id) {
      this.deleteItemId = item_id;
      this.dialogDelete = true;
    },

    deleteItemConfirm() {
      if (this.deleteItemId > 0) {
        this.closeDelete();
        ApiService.delete(`reporting/brand-reports/${this.deleteItemId}`).then(
          () => {
            logInfo("report eliminado");
            this.getDataFromApi();
          }
        );
      }
    },

    getQueryParams() {
      let query_params_string = "";
      let query_params = [];
      query_params.push("page=" + this.pageIndex);
      query_params.push("itemsPerPage=" + this.pageSize);
      if (this.sorting !== null) {
        for (const [key, value] of Object.entries(this.sorting)) {
          if (value !== null && value !== "") {
            query_params.push("sortby=" + key);
            query_params.push(
              "sortdesc=" + (value === "desc" ? "true" : "false")
            );
          }
        }
      }

      let filterModel = [];
      for (const [key, value] of Object.entries(this.filterCriteria)) {
        if (value !== "" && value !== null) {
          if (Object.keys(value).length > 0) {
            filterModel.push({
              columnField: key,
              filterValue: value
            });
          }
        }
      }
      let filter_columns = document.querySelectorAll(".filterable-column");
      for (let i = 0; i < filter_columns.length; i++) {
        filter_columns[i].classList.remove("filter_active");
      }
      if (filterModel.length > 0) {
        filterModel.map(filter_item => {
          for (let i = 0; i < filter_columns.length; i++) {
            if (filter_columns[i].classList.contains(filter_item.columnField)) {
              filter_columns[i].classList.add("filter_active");
            }
          }
          return filter_item;
        });
      }

      query_params_string += query_params.join("&");
      if (filterModel.length > 0) {
        query_params_string +=
          "&filterModel=" + encodeURIComponent(JSON.stringify(filterModel));
      }
      return query_params_string;
    },

    async getDataFromApi() {
      this.show();
      let query_params_string = this.getQueryParams();
      let fetch_url = "reporting/brand-reports";
      if (query_params_string !== "") {
        fetch_url += "?" + query_params_string;
      }
      try {
        const resp = await ApiService.get(fetch_url);
        this.reports = resp.data;
        if (this.reports.length > 0) {
          this.showEmpty = false;
        } else {
          this.showEmpty = true;
        }
        this.totalreports = resp.total;
        this.close();
      } catch (error) {
        this.close();
      }
    },

    searchConfirm(closeFn) {
      closeFn();
      this.pageIndex = 1;
      this.getDataFromApi();
    },

    searchCancel(closeFn, cancelFilterKey) {
      closeFn();
      this.filterCriteria[cancelFilterKey] = {};
      this.getDataFromApi();
    },

    init() {
      this.getDataFromApi();
      this.search_brand_list();
    }
  },
  async mounted() {
    this.init();
  }
};
</script>

<style></style>
